import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// English translations
import enCommon from './locales/en/common.json';
import enPages from './locales/en/pages.json';
import enPantry from './locales/en/pantry.json';
import enCooking from './locales/en/cooking.json';
import enRecipe from './locales/en/recipe.json';
import enAuth from './locales/en/auth.json';

// Arabic translations
import arCommon from './locales/ar/common.json';
import arPages from './locales/ar/pages.json';
import arPantry from './locales/ar/pantry.json';
import arCooking from './locales/ar/cooking.json';
import arRecipe from './locales/ar/recipe.json';
import arAuth from './locales/ar/auth.json';

const savedLanguage = (() => {
  try {
    const stored = localStorage.getItem('language-preference');
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed?.state?.language ?? 'en';
    }
  } catch {
    // ignore
  }
  return 'en';
})();

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      pages: enPages,
      pantry: enPantry,
      cooking: enCooking,
      recipe: enRecipe,
      auth: enAuth,
    },
    ar: {
      common: arCommon,
      pages: arPages,
      pantry: arPantry,
      cooking: arCooking,
      recipe: arRecipe,
      auth: arAuth,
    },
  },
  lng: savedLanguage,
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common', 'pages', 'pantry', 'cooking', 'recipe', 'auth'],
  interpolation: {
    escapeValue: false, // React already escapes
    // Render all interpolated numbers as Arabic-Indic digits (٠-٩) in the Arabic UI.
    // alwaysFormat runs this on every interpolated value; we only transform for `ar`.
    alwaysFormat: true,
    format: (value, _format, lng) => {
      if (lng === 'ar' && value != null) {
        // Arabic-Indic digits ٠-٩ occupy the contiguous block U+0660–U+0669.
        return String(value).replace(/[0-9]/g, (d) => String.fromCharCode(0x0660 + Number(d)));
      }
      return value;
    },
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
